import { Component, Input } from '@angular/core';
import { LucideAngularModule, UserX } from 'lucide-angular';

@Component({
    selector: 'app-account-deactivated-modal',
    standalone: true,
    imports: [LucideAngularModule],
    template: `
        <div class="text-center py-6">
            <div class="mb-4 flex justify-center">
                <lucide-icon [img]="UserX" [size]="64" class="text-tertiary"></lucide-icon>
            </div>
            <p class="text-gray-600 mb-6">
                {{ message || 'Your account has been deactivated. You will be redirected to the login page.' }}
            </p>
            <button (click)="returnToLogin()" class="button button--primary">Return to Login</button>
        </div>
    `,
    styles: [],
})
export class AccountDeactivatedModalComponent {
    @Input() message?: string;
    readonly UserX = UserX;

    returnToLogin(): void {
        window.location.reload();
    }
}
